// ts`, unchanged, so the Section 180 letter/workbook and any UI surfacing the SAME figure cannot
// drift apart — the panel's per-field "Total Excess Fertility" is literally the number the letter
// prints for that field (`fig.
export const fmtMoney = (v: number): string =>
  "$" +
  v.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
